export const moduleWrapper = {
  current: undefined
};